import React from 'react';
import { Helmet } from 'react-helmet-async';

const NoIndexHelmet = ({ title }) => (
  <Helmet>
    {title && <title>{title}</title>}
    <meta name="robots" content="noindex, nofollow" />
  </Helmet>
);

export default NoIndexHelmet;
